interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const navBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700";

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        className={navBtn}
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line text-base"></i>
        </span>
        上一页
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span
            key={`ellipsis-${idx}`}
            className="flex h-9 w-6 items-center justify-center text-sm text-foreground-400"
          >
            …
          </span>
        ),
      )}

      <button
        type="button"
        className={navBtn}
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line text-base"></i>
        </span>
      </button>
    </div>
  );
}